import React from 'react';
import { connect } from 'react-redux';
import ValueInvestment from './ValueInvestment';
import { REDUCER_NAME, setTypeRanking } from '../fiinTradeStrategy/reducer';
import './Header.scss';
import { I18n } from 'react-redux-i18n';
import ExportStrategy from '../fiinTradeStrategy/common/Export';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCheckBox: [
        {
          key: 'industry',
          value: true,
        },
        {
          key: 'group',
          value: false,
        },
      ],
    };
  }

  render() {
    const { title, firstStrName, secondStrName, color, data } = this.props;
    return (
      <div className="px-20">
        <div className="value-header d-flex">
          <ValueInvestment
            title={title}
            firstStrName={firstStrName}
            secondStrName={secondStrName}
            color={color}
            data={data}
          />
        </div>
        <div className="calculated strategy-text-no-wrap d-flex justify-content-between mt-10 mb-10">
          <span className="strCalculated">
            {I18n.t('strategy.strCalculated')}
          </span>
          <ExportStrategy {...this.props} />
        </div>
      </div>
    );
  }
}

Header.defaultProps = {
  data: {
    averageIndex: null,
    averageStock: null,
  },
};

const mapStateToProps = state => {
  return {
    typeRanking: state[REDUCER_NAME].typeRanking,
    currentTab: state[REDUCER_NAME].currentTab,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  setTypeRanking,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
